import { type MetaFunction } from '@remix-run/node'
import { EyebrowLabel } from '#app/components/eyebrow-label.tsx'
import { EndCap } from './components/end-cap.tsx'
import { FeatureRow } from './components/feature-row.tsx'
import { MarketingHero } from './components/marketing-hero.tsx'
import { MarketingSection } from './components/marketing-section.tsx'

export const meta: MetaFunction = () => [
	{ title: 'For coaches — Momentum' },
	{
		name: 'description',
		content:
			'Programming is design. One language, every athlete. Coaching that scales without losing the craft.',
	},
]

export default function CoachRoute() {
	return (
		<>
			<MarketingHero
				eyebrow="For coaches"
				heading="Programming is design."
				subhead="One language, every athlete. Coaching that scales without losing the craft."
				decorations={['grid']}
			/>

			<MarketingSection>
				<EyebrowLabel>The current shape of coaching</EyebrowLabel>
				<h2 className="mt-5 font-display text-display-2">
					Spreadsheets, DMs, and apps that swallow your voice.
				</h2>
				<p className="mt-5 max-w-2xl text-base leading-relaxed text-ink-fg-soft">
					Programs lose nuance in translation. Adherence is invisible. Coaches
					are left wondering if their athlete is struggling, coasting, or
					crushing it.
				</p>
			</MarketingSection>

			<MarketingSection tone="ink-soft">
				<EyebrowLabel>What Momentum gives coaches</EyebrowLabel>
				<FeatureRow
					className="mt-12"
					variant="numbered"
					items={[
						{
							number: '01',
							heading: 'Write programs in one notation',
							body: 'A single language for one client or a whole roster. Layer planning factors on top to guide and track development across phases.',
						},
						{
							number: '02',
							heading: "See who's doing the work",
							body: 'Adherence at every scope: solo athlete, group, season.',
						},
						{
							number: '03',
							heading: 'Bring your team',
							body: 'Invite your clients, colleagues, and teams to train with Momentum.',
						},
					]}
				/>
			</MarketingSection>

			<MarketingSection tone="cream">
				<EyebrowLabel tone="cream">Training With Momentum</EyebrowLabel>
				<blockquote className="mt-6 max-w-3xl font-display text-display-3 italic text-cream-fg">
					"Training isn't just about the exercises — it's the relationship.
					Between a coach and an athlete. Between a coach and a team. The work
					happens there. Momentum is built to support that relationship, and the
					progression that happens within it."
				</blockquote>
			</MarketingSection>

			<EndCap />
		</>
	)
}
